document.addEventListener('click', async (e) => {

  function formatMoney(amount) {

  const currency =
    Shopify?.currency?.active ||
    window.Shopify?.currency?.active ||
    'AUD';

  let formatted = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency
  }).format(amount);

  // Remove A from A$
  if (currency === 'AUD') {
    formatted = formatted.replace('A$', '$');
  }

  return formatted;

}

  /* ===============================
     SINGLE VARIANT ADD TO CART
  =============================== */
  const addBtn = e.target.closest('.rp-add-to-cart');
  if (addBtn) {
    e.preventDefault();

    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    const originalText = addBtn.textContent;
    addBtn.textContent = 'Adding...';
    addBtn.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      const data = await response.json();
      addBtn.textContent = '✔ Added';

      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (drawer.__vue__ && typeof drawer.__vue__.renderContents === 'function') {
          drawer.__vue__.renderContents();
        }
        drawer.open();
      }

    } catch (err) {
      console.error(err);
      addBtn.textContent = originalText;
    }

    setTimeout(() => {
      addBtn.textContent = originalText;
      addBtn.disabled = false;
    }, 1500);

    return;
  }

  /* ===============================
     MULTI VARIANT → MODAL
  =============================== */


  

  const selectBtn = e.target.closest('.rp-select-options');
  if (selectBtn) {
    e.preventDefault();

    const handle = selectBtn.dataset.handle;
    const modal = document.getElementById('rp-modal');
    const body = modal.querySelector('.rp-modal-body');

    modal.classList.add('active');
    body.innerHTML = 'Loading...';

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      /* ===============================
   CUSTOM SALE TAG DISCOUNT
=============================== */

let salePercentage = 0;

// product tags loop
if (product.tags && product.tags.length) {

  product.tags.forEach(tag => {

    if (tag.includes('SALE_')) {

      salePercentage = parseInt(
        tag.replace('SALE_', '')
      );

    }

  });

}

// original price
let originalPrice = product.price / 100;

// final discounted price
let discountedPrice = originalPrice;

if (salePercentage > 0) {

  discountedPrice =
    originalPrice - (originalPrice * salePercentage / 100);

}

      let html = `
        <div class="quick-view-product">
          <div class="quick-featureimage">
            <img src="${product.featured_image || product.images[0]}" 
                 alt="${product.title}" 
                 class="quick-view-image">
                  <!-- View Full Details Button -->
            <div class="view-full-details">
              <a href="/products/${handle}" class="view-details-btn">
                View full details →
              </a>
            </div>
          </div>

          <div class="quick-productdetails">
            <div class="vendor">${product.vendor || ''}</div>
            <h2>${product.title}</h2>
            <div class="price">

  ${
    salePercentage > 0
      ? `
        <div class="custom-sale-price">
          <span class="old-price">
            ${formatMoney(originalPrice)}
          </span>

          <span class="new-price">
            ${formatMoney(discountedPrice)}
          </span>

          <span class="sale-badge">
            ${salePercentage}% OFF
          </span>
        </div>
      `
      : `
        <span class="normal-price">
          ${formatMoney(originalPrice)}
        </span>
      `
  }

</div>
            <div class="tax-shipping">
              Tax included.
              <a href="/policies/shipping-policy">Shipping</a>
              calculated at checkout.
            </div>

            <div class="option-group">
              <label class="option-label">
                ${product.options?.[0]?.name || 'Variant'}
              </label>
              <div class="variant-options">
                ${product.variants.map(v =>
                  `<button type="button" class="variant-btn" data-id="${v.id}">
                    ${v.title}
                  </button>`
                ).join('')}
              </div>
            </div>

            <div class="option-group">
              <label class="option-label">Quantity</label>
              <div class="quantity-wrapper">
                <button type="button" class="qty-decrement">-</button>
                <input type="number" value="1" min="1">
                <button type="button" class="qty-increment">+</button>
              </div>
            </div>

            <!-- ✅ SHOP PAY NEEDS FORM -->
            <form class="shop-pay-form" action="/cart/add" method="post">
              <input type="hidden" name="id" value="${product.variants[0].id}">

              <button type="button" class="modal-add-to-cart">
                Add to cart
              </button>

              <div class="shop-pay-wrapper">
                <div class="shopify-payment-button" data-shopify="payment-button"></div>
              </div>
            </form>
           

          </div>
        </div>
      `;

      body.innerHTML = html;

      /* ✅ INIT SHOP PAY BUTTON */
      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      let selectedVariantId = product.variants[0].id;
      const qtyInput = body.querySelector('.quantity-wrapper input');
      const variantInput = body.querySelector('.shop-pay-form input[name="id"]');

      /* ===============================
         VARIANT SELECTION
      =============================== */
      body.querySelectorAll('.variant-btn').forEach(btn => {
  btn.onclick = () => {
    // deselect all
    body.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');

    // update selected variant ID
    selectedVariantId = btn.dataset.id;
    variantInput.value = selectedVariantId;

    // find the selected variant object
    const selectedVariant = product.variants.find(v => v.id == selectedVariantId);

    // 🔹 Update main image
    body.querySelector('.quick-view-image').src =
      selectedVariant?.featured_image?.src || product.featured_image || product.images[0];

    // 🔹 Update price dynamically
const priceEl = body.querySelector('.price');

if (priceEl && selectedVariant) {

  const variantPrice = selectedVariant.price / 100;

  let finalVariantPrice = variantPrice;

  if (salePercentage > 0) {

    finalVariantPrice =
      variantPrice - (variantPrice * salePercentage / 100);

    priceEl.innerHTML = `
      <div class="custom-sale-price">

        <span class="old-price">
          ${formatMoney(variantPrice)}
        </span>

        <span class="new-price">
          ${formatMoney(finalVariantPrice)}
        </span>

        <span class="sale-badge">
          ${salePercentage}% OFF
        </span>

      </div>
    `;

  } else {

    priceEl.innerHTML = `
      <span class="normal-price">
        Rs. ${variantPrice.toFixed(2)}
      </span>
    `;

   }

    }

  };

});
      /* ✅ DEFAULT SELECT FIRST VARIANT VISUALLY */
const firstVariantBtn = body.querySelector('.variant-btn');
if (firstVariantBtn) {
  firstVariantBtn.classList.add('selected');
}

      /* ===============================
         QUANTITY
      =============================== */
      body.querySelector('.qty-decrement').onclick = () =>
        qtyInput.value = Math.max(1, qtyInput.value - 1);

      body.querySelector('.qty-increment').onclick = () =>
        qtyInput.value = parseInt(qtyInput.value) + 1;

      /* ===============================
         ADD TO CART (JS)
      =============================== */
      body.querySelector('.modal-add-to-cart').onclick = async () => {
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: selectedVariantId,
              quantity: parseInt(qtyInput.value)
            })
          });

          const data = await response.json();

          document.dispatchEvent(
            new CustomEvent('cart:refresh', { detail: data })
          );

          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            if (drawer.__vue__?.renderContents) {
              drawer.__vue__.renderContents();
            }
            drawer.open();
          }

          modal.classList.remove('active');

        } catch (err) {
          console.error(err);
          alert('Failed to add product to cart');
        }
      };

    } catch (err) {
      console.error(err);
      body.innerHTML = 'Failed to load product';
    }

    return;
  }

  /* ===============================
     CLOSE MODAL
  =============================== */
  if (
    e.target.classList.contains('rp-modal-close') ||
    e.target.classList.contains('rp-modal-overlay')
  ) {
    document.getElementById('rp-modal')?.classList.remove('active');
  }

});
